import { render, staticRenderFns } from "./firstSupplierTask.vue?vue&type=template&id=32814fc5&scoped=true"
import script from "./firstSupplierTask.vue?vue&type=script&lang=js"
export * from "./firstSupplierTask.vue?vue&type=script&lang=js"
import style0 from "./firstSupplierTask.vue?vue&type=style&index=0&id=32814fc5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32814fc5",
  null
  
)

export default component.exports